import moment from "moment";
import * as React from "react";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import TableRow from "@mui/material/TableRow";
import EditIcon from "@mui/icons-material/Edit";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import { Popover, MenuItem } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import Label from "../components/label";
import Iconify from "../components/iconify";
import OrdersRowHistory from "./OrdersRowHistory";
import {
	ordersTableColumns,
	orderStatusTranslationConformity,
	deliveryTypeTranslationConformity,
} from "./common";
import { OrderStatus } from "./orders.status.enum";
import { UserRoles } from "../employee-page/user-roles.enum";
import palette from "../theme/palette";

export default function OrdersRow({ row, buttonsActive, actions, authScope }) {
	const [open, setOpen] = React.useState(false);
	const [openButtons, setOpenButtons] = React.useState(null);

	const handleEditRowClick = () => {
		actions.editRow(row.id);
	};
	const handleDeleteRowClick = () => {
		actions.tryDeleteRow(row.id);
	};

	const handleOpenMenu = (event) => {
		setOpenButtons(event.currentTarget);
	};
	const handleCloseMenu = () => {
		setOpenButtons(null);
	};
	return (
		<React.Fragment>
			<TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
				{ordersTableColumns.map((column) => (
					<TableCell
						key={column.id}
						align="left"
						style={{ maxWidth: column.maxWidth }}
					>
						{column.id === "collapseButton" && (
							<IconButton
								aria-label="expand row"
								size="small"
								onClick={() => setOpen(!open)}
							>
								{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
							</IconButton>
						)}
						{column.id === "orderNumber" && (
							<Typography variant="subtitle2" noWrap>
								<Box sx={{ fontWeight: "bold", m: 1 }}>{row.orderNumber}</Box>
							</Typography>
						)}
						{column.id === "createdAt" &&
							moment(row.date).format("DD MMM HH:mm YYYY")}
						{column.id === "driver" && row.driver?.name}
						{column.id === "clientName" && row.clientName}
						{column.id === "status" && (
							<Typography
								variant="subtitle2"
								noWrap
								sx={{
									background:
										row.status === OrderStatus.CREATED
											? palette.info.main
											: "white",
									borderRadius: "5px",
								}}
							>
								{orderStatusTranslationConformity[row.status] ===
									orderStatusTranslationConformity.ASSEMBLY_FINISHED &&
								row.npCodes &&
								row.npCodes.length > 0
									? orderStatusTranslationConformity.MARKED_TTN
									: orderStatusTranslationConformity[row.status]}
							</Typography>
						)}
						{column.id === "statusNP" && (
							<Box>
								<Button
									variant="contained"
									color="info"
									size="small"
									disabled={!row.npCodes || row.npCodes.length < 1}
									onClick={() => actions.showNPModal(row.npCodes)}
								>
									Переглянути
								</Button>
								<Typography>Всього ТТН: {row.npCodes?.length}</Typography>
							</Box>
						)}
						{column.id === "archived" && (
							<Label color={(row.archived && "error") || "success"}>
								{row.archived ? "архівна" : "активна"}
							</Label>
							// <Checkbox disabled checked={row.archived} />
						)}
						{column.id === "employee1c" && row.employee1c}
						{column.id === "managerUser" && row.managerUser?.name}
						{column.id === "storage" && row.storage}
						{column.id === "warehouse" &&
							(row.warehouse ? `${row.warehouse.city}` : "")}
						{column.id === "deliveryType" &&
							deliveryTypeTranslationConformity[row.deliveryType]}
						{column.id === "deliveryAddress" && row.deliveryAddress}
						{authScope === UserRoles.ADMIN && column.id === "buttons" && (
							// no idea why border is spawning
							<TableCell align="right" sx={{ borderBottom: 0 }}>
								<IconButton
									size="large"
									color="inherit"
									onClick={handleOpenMenu}
								>
									<Iconify icon={"eva:more-vertical-fill"} />
								</IconButton>
							</TableCell>
						)}
						{/* {column.id === "buttons" && (
							<div style={{ display: "flex", gap: 15 }}>
								<ButtonGroup
									disabled={!buttonsActive}
									variant="outlined"
									aria-label="outlined button group"
								>
									<Button onClick={() => handleEditRowClick()}>
										<EditIcon />
									</Button>
									<Button onClick={() => handleDeleteRowClick()} color="error">
										<DeleteIcon />
									</Button>
								</ButtonGroup>
							</div>
						)} */}
					</TableCell>
				))}
			</TableRow>
			<OrdersRowHistory open={open} orderHandleTacts={row.orderHandleTacts} />

			<Popover
				open={Boolean(openButtons)}
				anchorEl={openButtons}
				onClose={handleCloseMenu}
				anchorOrigin={{ vertical: "top", horizontal: "left" }}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				PaperProps={{
					sx: {
						p: 1,
						width: 140,
						"& .MuiMenuItem-root": {
							px: 1,
							typography: "body2",
							borderRadius: 0.75,
						},
					},
				}}
			>
				<MenuItem onClick={() => handleEditRowClick()}>
					<Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
					Редагувати
				</MenuItem>

				<MenuItem
					sx={{ color: "error.main" }}
					onClick={() => handleDeleteRowClick()}
				>
					<Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
					Видалити
				</MenuItem>
			</Popover>
		</React.Fragment>
	);
}
